// Assets
import { HTMLAttributes } from 'react';
import { ReactComponent as StarIcon } from '../../assets/star.svg';

import './rate-us.scss';

const RateUs: React.FunctionComponent<HTMLAttributes<HTMLDivElement>> = ({ children, ...props }) => {
	return (
		<div className="rate-us" {...props}>
			<StarIcon />
			<span className="rate-us__title">Rate us!</span>
		</div>
	);
};

export default RateUs;
